function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
export default function plpInfoCard() {
  document.addEventListener('DOMContentLoaded', function () {
    var productGrid = document.querySelector('#ProductGridContainer #product-grid');
    if (productGrid !== null) {
      var productCards = productGrid.querySelectorAll('.grid__item:not(.info-card__wapper)'),
        bandInfoCards = document.querySelectorAll('li.brand-info'),
        productInfoCards = document.querySelectorAll('li.product-info'),
        reviewInfoCards = document.querySelectorAll('li.reviews-info'),
        bandInfoCardsArray = _toConsumableArray(bandInfoCards),
        productInfoCardsArray = _toConsumableArray(productInfoCards),
        reviewInfoCardsArray = _toConsumableArray(reviewInfoCards);
      var insertInfoCard = function insertInfoCard() {
        var position = 3;
        if (productCards !== null) {
          if (productCards.length > position) {
            if (bandInfoCardsArray[0] !== undefined) {
              var _productCards$positio;
              (_productCards$positio = productCards[position]) === null || _productCards$positio === void 0 || _productCards$positio.before(bandInfoCardsArray[0]);
            }
            if (productInfoCardsArray[0] !== undefined) {
              var _productCards$positio2;
              (_productCards$positio2 = productCards[position]) === null || _productCards$positio2 === void 0 || _productCards$positio2.before(productInfoCardsArray[0]);
            }
            if (reviewInfoCardsArray[0] !== undefined) {
              var _productCards$positio3;
              (_productCards$positio3 = productCards[position]) === null || _productCards$positio3 === void 0 || _productCards$positio3.before(reviewInfoCardsArray[0]);
            }
          }
        }
      };
      insertInfoCard();
    }
  });
}